import { React, useRef } from "react";
import "./experts.scss";

import ArrowLeft from "../../images/ArrowLeft2.svg";
import ArrowRight from "../../images/ArrowRight2.svg";
import Kaneke from "../../images/Kaneke.jpeg";
import Ulan from "../../images/Ulan.jpeg";
import Men from "../../images/Men.jpeg";
import Zhake from "../../images/Zhake.jpeg";
import Khaseke from "../../images/Khaseke.jpeg";
import Nureke from "../../images/Nureke.jpeg";
import Bolat from "../../images/Bolat.jpeg";
import Saken from "../../images/Saken.jpeg";
import Nagima from "../../images/Nagima.jpeg";

const Experts = () => {
  const ref = useRef(null);

  const scroll = (direction) => {
    const scrollAmount = direction === 'left' ? -350 : 350; // Скролл қадамын көбейттік
    ref.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  return (
    <div className="experts">
      <div className="experts_inner">
        <div className="experts_header">
          <div className="experts_header_title">Біздің оқытушылар</div>
          <div className="experts_header_arrows">
            <button className="experts_arrow" onClick={() => scroll('left')}>
              <img src={ArrowLeft} alt="Back" />
            </button>
            <button className="experts_arrow" onClick={() => scroll('right')}>
              <img src={ArrowRight} alt="Next" />
            </button>
          </div>
        </div>

        <div className="experts_cards_container_outside">
          <div ref={ref} className="experts_cards_container">
            {/* Хасен */}
            <div className="expert_card">
              <div className="expert_img_wrapper">
                <img src={Khaseke} alt="Hasen" className="expert_img" />
              </div>
              <div className="expert_info">
                <div className="expert_name">Жантелі Хасен Асқарұлы</div>
                <div className="expert_position">Мектеп директоры, PhD</div>
                <div className="expert_experience">Жұмыс өтілі: 26 жыл</div>
                <div className="expert_subject">C# программалау тілі</div>
                <div className="expert_phone">+7 707 979 8648</div>
              </div>
            </div>

            {/* Сәкен */}
            <div className="expert_card">
              <div className="expert_img_wrapper">
                <img src={Saken} alt="Saken" className="expert_img" />
              </div>
              <div className="expert_info">
                <div className="expert_name">Длимбетов Сәкен Серікұлы</div>
                <div className="expert_position">Директор орынбасары</div>
                <div className="expert_experience">Жұмыс өтілі: 16 жыл</div>
                <div className="expert_phone">+7 777 297 7700</div>
              </div>
            </div>



            {/* Қанат */}
            <div className="expert_card">
              <div className="expert_img_wrapper">
                <img src={Kaneke} alt="Kanat" className="expert_img" />
              </div>
              <div className="expert_info">
                <div className="expert_name">Сәрсенбаев Қанат Әділханұлы</div>
                <div className="expert_position">Оқытушы, PhD</div>
                <div className="expert_experience">Жұмыс өтілі: 18 жыл</div>
                <div className="expert_subject">AI және Python</div>
                <div className="expert_phone">+7 705 994 6008</div>
              </div>
            </div>

            {/* Жандос */}
            <div className="expert_card">
              <div className="expert_img_wrapper">
                <img src={Zhake} alt="Zhandos" className="expert_img" />
              </div>
              <div className="expert_info">
                <div className="expert_name">Жунисов Жандос Мухидинұлы</div>
                <div className="expert_position">Оқытушы</div>
                <div className="expert_experience">Жұмыс өтілі: 14 жыл</div>
                <div className="expert_subject">Дизайн және анимация</div>
              </div>
            </div>

            {/* Әлібек */}
            <div className="expert_card">
              <div className="expert_img_wrapper">
                <img src={Men} alt="Alibek" className="expert_img" />
              </div>
              <div className="expert_info">
                <div className="expert_name">Бекнияз Әлібек Азаматұлы</div>
                <div className="expert_position">Оқытушы, Магистр</div>
                <div className="expert_experience">Жұмыс өтілі: 4 жыл</div>
                <div className="expert_subject">Frontend әзірлеу</div>
                <div className="expert_phone">+7 747 726 0073</div>
              </div>
            </div>

            {/* Ұлан */}
            <div className="expert_card">
              <div className="expert_img_wrapper">
                <img src={Ulan} alt="Ulan" className="expert_img" />
              </div>
              <div className="expert_info">
                <div className="expert_name">Абихан Ұлан Манапұлы</div>
                <div className="expert_position">Оқытушы, Магистр</div>
                <div className="expert_experience">Жұмыс өтілі: 4 жыл</div>
                <div className="expert_subject">Backend және Mobile</div>
                <div className="expert_phone">+7 747 443 3049</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default Experts;